import gql from "graphql-tag";
import { getApolloClient } from "../../apollo/client";
import { getRoleQuery } from "../query/getRole.query";

const getUserRoleRequest = async () => {
  try {
    const res = await getApolloClient().mutate({
      mutation: gql`
        ${getRoleQuery()}
      `,
    });
    return res.data.getRoleJwt;
  } catch (ex) {
    console.log(ex);
  }
};

export { getUserRoleRequest };